export class FeaturedCollectionComponent extends HTMLElement {
  constructor() {
    super();
    this.buttons = [];
    this.productGrids = [];
    this.links = [];
  }
  connectedCallback() {
    this.init();
  }
  init() {
    // Find all product grids, buttons, and links
    this.productGrids = this.querySelectorAll(".grid-container");
    this.buttons = this.querySelectorAll('button[type="button"]');
    this.links = this.querySelectorAll(".link-button");

    if (this.buttons.length === 0) {
      return;
    }

    if (this.productGrids.length === 0) {
      return;
    }

    this.buttons.forEach((button, index) => {
      button.addEventListener("click", () => this.switchCollection(index));
    });

    this.setActiveButton(0);
    this.showGrid(0);
    this.showLink(0);
  }

  switchCollection(buttonIndex) {
    // Update active button
    this.setActiveButton(buttonIndex);

    // Show the corresponding grid
    this.showGrid(buttonIndex);

    // Show the corresponding link
    this.showLink(buttonIndex);
  }

  showGrid(gridIndex) {
    // First, hide all grids immediately to prevent stacking
    this.productGrids.forEach((grid, index) => {
      if (index !== gridIndex) {
        grid.style.display = "none";
        grid.style.visibility = "hidden";
        grid.style.opacity = "0";

        // Reset child elements opacity
        const children = grid.querySelectorAll(".grid-layout > *");
        children.forEach((child) => {
          child.style.opacity = "0";
          child.style.transform = "translateY(10px)";
        });
      }
    });

    // Then show the target grid with fade in
    const targetGrid = this.productGrids[gridIndex];
    if (targetGrid) {
      targetGrid.style.display = "block";
      targetGrid.style.visibility = "visible";
      targetGrid.style.opacity = "1";

      // Get all child elements in the grid-layout
      const children = targetGrid.querySelectorAll(".grid-layout > *");

      // Reset children to initial state
      children.forEach((child) => {
        child.style.opacity = "0";
        child.style.transform = "translateY(10px)";
        child.style.transition = "opacity 0.6s ease, transform 0.6s ease";
      });

      // Staggered fade in for children
      children.forEach((child, index) => {
        setTimeout(() => {
          child.style.opacity = "1";
          child.style.transform = "translateY(0)";
        }, 100 + index * 50); // 100ms delay between each child
      });
    }
  }

  showLink(linkIndex) {
    // Hide all links first
    this.links.forEach((link, index) => {
      if (index === linkIndex) {
        link.style.display = "flex";
        link.style.opacity = "1";
      } else {
        link.style.display = "none";
        link.style.opacity = "0";
      }
    });
  }

  setActiveButton(activeIndex) {
    this.buttons.forEach((button, index) => {
      if (index === activeIndex) {
        button.classList.add("active");
        button.setAttribute("aria-pressed", "true");
      } else {
        button.classList.remove("active");
        button.setAttribute("aria-pressed", "false");
      }
    });
  }
}

customElements.define(
  "featured-collection-component",
  FeaturedCollectionComponent
);
